import { JWT } from "../../../shared";
import { LOGOUT, LOGIN_SUCCESS, LOGIN_FAILED } from "./constants";
import { AuthService } from "../../../services";

// const user={
//   id:"",
//   firstName: "",
//   lastName: "",
//   email: "",
//   role: "",
// }
const initialState = {
  isLoggedIn: JWT.isValidToken(),
  access_token: JWT.getJwt(),
  user: AuthService.getLoginUser(),
};

const authReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOGIN_SUCCESS:
      return {
        ...state,
        isLoggedIn: true,
        access_token: action.payload.access_token,
        user: action.payload.user,
      };
    case LOGIN_FAILED:
      return { ...state, isLoggedIn: false, access_token: null, user: null };
    case LOGOUT:
      return { ...state, isLoggedIn: false, access_token: null, user: null };
    default:
      return state;
  }
};

export default authReducer;
